import React from 'react';
import { FadeIn } from './FadeIn';
import { Trophy, ArrowRight, Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferCards() {
  return <section id="comprar" className="py-10 px-4 max-w-5xl mx-auto" data-id="element-136">
      <FadeIn className="text-center mb-6" data-id="element-137">
        <h2 className="text-3xl md:text-5xl text-mint mb-3 uppercase font-['Open_Sans',_sans-serif] font-[900]" data-id="element-138">
          Elegí tu opción
        </h2>
      </FadeIn>

      {/* Pricing Cards */}
      <div className="grid md:grid-cols-2 gap-5 mb-6" data-id="element-139">
        {/* Card 1: Megapack */}
        <FadeIn delay={0.1} data-id="element-140">
          <div className="relative bg-surface border border-mint/15 rounded-3xl p-8 flex flex-col h-full shadow-lg shadow-black/40" data-id="element-141">
            <div className="mb-4" data-id="element-142">
              <h3 className="text-dark text-xl font-[900] font-['Open_Sans',_sans-serif] uppercase mb-2" data-id="element-143">
                🥕 Megapack Nutripro Listo
              </h3>
              <p className="text-dark/70 text-sm font-medium" data-id="element-144">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-6 flex-1" data-id="element-145">
              <p className="text-dark/50 line-through text-base mb-1" data-id="element-146">
                Antes: $34.990 ARS
              </p>
              <p className="text-4xl md:text-5xl font-[900] text-dark font-['Open_Sans',_sans-serif]" data-id="element-147">
                $19.990
                <span className="text-base text-dark/60 font-normal ml-2" data-id="element-148">
                  ARS
                </span>
              </p>
            </div>

            <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwTkYc0jPVzOcWmb07wSg/es-ar?_r=AQABOh3_y5o0n906Mqws4ivAq5RkQJOK5cqOLDDedCXRGTQ&cart_link_id=1TztK5e8&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 20px rgba(74,222,128,0.3)'
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-gradient-to-r from-mint to-secondary hover:from-mint/90 hover:to-secondary/90 text-white font-[900] text-base py-4 px-6 rounded-xl shadow-lg shadow-mint/20 transition-all font-['Open_Sans',_sans-serif] flex items-center justify-center gap-2 border border-mint/30" data-id="element-149">
              <ArrowRight size={18} data-id="element-150" />
              QUIERO MI MEGAPACK
            </motion.a>
          </div>
        </FadeIn>

        {/* Card 2: Plus (Highlighted) */}
        <FadeIn delay={0.2} data-id="element-151">
          <motion.div id="oferta-plus" className="relative bg-surface border-2 border-mint rounded-3xl p-8 flex flex-col h-full shadow-xl" animate={{
          boxShadow: ['0 0 20px rgba(74,222,128,0.15)', '0 0 40px rgba(74,222,128,0.3)', '0 0 20px rgba(74,222,128,0.15)']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-152">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-gradient-to-r from-mint to-secondary text-white font-bold px-5 py-2 rounded-full text-sm shadow-lg shadow-mint/40 border border-mint/50" data-id="element-153">
              <Trophy size={16} fill="currentColor" className="text-accent" data-id="element-154" />
              La más elegida
            </div>

            <div className="mb-4 mt-4" data-id="element-155">
              <h3 className="text-mint text-xl font-[900] font-['Open_Sans',_sans-serif] uppercase mb-2" data-id="element-156">
                🚀 Megapack Nutripro + KIT PROFESIONAL
              </h3>
              <p className="text-dark/80 text-sm font-medium leading-relaxed" data-id="element-157">
                Accedé al Megapack completo + kKIT PROFESIONAL, con herramientas
                para evaluación, honorarios, gestión, marketing, crecimiento
                profesional y evaluación antropometrica.
              </p>
            </div>

            <div className="mb-6 flex-1" data-id="element-158">
              <p className="text-dark/50 line-through text-base mb-1" data-id="element-159">
                Antes: $43.990 ARS
              </p>
              <p className="text-4xl md:text-5xl font-[900] text-mint font-['Open_Sans',_sans-serif]" data-id="element-160">
                $27.990
                <span className="text-base text-dark/60 font-normal ml-2" data-id="element-161">
                  ARS
                </span>
              </p>
            </div>

            <motion.a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwU2fxxoZKry1E28dbN7i/es-ar?_r=AQABUz-DDfQSB1cPsEXTz0QcvPazglRT5B40d_lxn2LWtqI&cart_link_id=psdRzX2L&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 25px rgba(74,222,128,0.5)'
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-gradient-to-r from-mint to-secondary hover:from-mint/90 hover:to-secondary/90 text-white font-[900] text-base py-4 px-6 rounded-xl shadow-lg shadow-mint/40 transition-all font-['Open_Sans',_sans-serif] flex items-center justify-center gap-2 border border-mint/50" data-id="element-162">
              🚀EMPEZAR AHORA
            </motion.a>
          </motion.div>
        </FadeIn>
      </div>

      {/* Subtitle */}
      <FadeIn delay={0.3} className="text-center mb-5" data-id="element-163">
        <p className="text-dark/60 text-sm italic" data-id="element-164">
          La más elegida por nutris que quieren profesionalizarse y cobrar lo
          que merecen
        </p>
      </FadeIn>

      {/* Trust Bar */}
      <FadeIn delay={0.4} data-id="element-165">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 bg-surface border border-mint/15 rounded-2xl py-4 px-5 max-w-3xl mx-auto shadow-lg shadow-black/40" data-id="element-166">
          <div className="flex items-center gap-2 text-dark/80 text-sm font-medium" data-id="element-167">
            <Lock size={16} className="text-mint" data-id="element-168" />
            Pago seguro
          </div>
          <div className="flex items-center gap-2 text-dark/80 text-sm font-medium" data-id="element-169">
            <Zap size={16} className="text-mint" data-id="element-170" />
            Acceso en 5 min
          </div>
          <div className="flex items-center gap-2 text-dark/80 text-sm font-medium" data-id="element-171">
            <ShieldCheck size={16} className="text-mint" data-id="element-172" />
            Garantía 7 días
          </div>
          <div className="flex items-center gap-2 text-dark/80 text-sm font-medium" data-id="element-173">
            <CreditCard size={16} className="text-mint" data-id="element-174" />
            Mercado Pago
          </div>
        </div>
      </FadeIn>
    </section>;
}